import { render, staticRenderFns } from "./mavonEditor.vue?vue&type=template&id=79843434&"
import script from "./mavonEditor.vue?vue&type=script&lang=js&"
export * from "./mavonEditor.vue?vue&type=script&lang=js&"
import style0 from "./mavonEditor.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports